<template>
    <products-wizard-provider v-slot="{
       products,
       isLoading,
       productsPage,
       productsPerPage,
       getNextProductsPage,
       getPreviousProductsPage,
       campaign,
   }" class="g-h-full">
        <products-list-view
            :products="products"
            :campaign="campaign"
            :is-loading="isLoading"
            :current-page="productsPage"
            :per-page="productsPerPage"
            @next-page="getNextProductsPage"
            @prev-page="getPreviousProductsPage"
        />
    </products-wizard-provider>
</template>
<script>
    import ProductsWizardProvider from "../providers/proposal-steps/ProductsWizardProvider";
    import ProductsListView from "../data-views/products/ProductsListView";

    export default {
        name: "ProductSelectionProductsRouterView",
        components: {
            ProductsWizardProvider,
            ProductsListView
        },
    }
</script>
